exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item[data-v-70dab770] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 10px;\n}\n#courseContent[data-v-70dab770] {\n  overflow: hidden;\n}\n#courseContent .drawer-content--scroll[data-v-70dab770] {\n  height: calc(100vh - 64px);\n  width: 100%;\n  overflow: auto;\n}", ""]);

// exports
